<template>
    <v-container fluid class="pa-0">
        <banner 
            :title="$t('OpenProjectsPageTitle')"
            :description="$t('OpenProjectsPageDescription')"
        />
        <v-container>
            <template v-if="loadingProjects || loadingTopics">
                <div class="text-center">
                    <v-progress-circular
                        :size="50"
                        color="secondary"
                        indeterminate
                    ></v-progress-circular>
                </div>
            </template>
            <template v-else>
                <!-- Biding list -->
                <v-card flat color="grey lighten-4" class="custom-radius mb-6 pa-lg-2">
                    <v-card-title class="justify-center" v-text="$t('OpenProjectsAvailableToBid')"></v-card-title>
                    <template v-if="bidingList.length > 0">
                        <v-row justify="center" class="my-4">
                            <v-col 
                                cols="12" 
                                md="6" 
                                lg="3"
                                v-for="(project, index) in bidingList"
                                :key="index"
                            >
                                <project-card :project="project" :topic="topicById(project.topicId)"/>
                            </v-col>
                        </v-row>
                    </template>
                    <template v-else>
                        <v-card-subtitle class="pt-2 pb-1 text-center" v-text="$t('NoRecords')"></v-card-subtitle>
                    </template>
                </v-card>
                <!-- Voting list -->
                <v-card flat color="grey lighten-4" class="custom-radius pb-2 mb-6 px-lg-2">
                    <v-card-title class="justify-center" v-text="$t('BidsAvailableToVote')"></v-card-title>
                    <template v-if="votingList.length > 0">
                        <v-row justify="center" class="px-4">
                            <v-col 
                                cols="12" 
                                md="6" 
                                lg="3"
                                v-for="(project, index) in votingList"
                                :key="index"
                            >
                                <project-card :project="project" :topic="topicById(project.topicId)"/>
                            </v-col>
                        </v-row>
                    </template>
                    <template v-else>
                        <v-card-subtitle class="pt-2 pb-1 text-center" v-text="$t('NoRecords')"></v-card-subtitle>
                    </template>
                </v-card>
                <!-- review list -->
                <v-card flat color="grey lighten-4" class="custom-radius pb-2 mb-6 px-lg-2">
                    <v-card-title class="justify-center" v-text="$t('BidsUnderReview')"></v-card-title>
                    <template v-if="reviewList.length > 0">
                        <v-row justify="center" class="px-4">
                            <v-col 
                                cols="12" 
                                md="6" 
                                lg="3"
                                v-for="(project, index) in reviewList"
                                :key="index"
                            >
                                <project-card :project="project" :topic="topicById(project.topicId)"/>
                            </v-col>
                        </v-row>
                    </template>
                    <template v-else>
                        <v-card-subtitle class="pt-2 pb-1 text-center" v-text="$t('NoRecords')"></v-card-subtitle>
                    </template>
                </v-card>
            </template>
        </v-container>
    </v-container>
</template>

<script>
    import moment from 'moment'
    import { mapGetters } from 'vuex'
    import Banner from '@/components/pageBanner'
    import ProjectCard from '@/components/projectCard'

    export default {
        name: 'openProjects',
        data: () => ({
            bidingList: [],
            votingList: [],
            reviewList: [],
            topics: [],
            snackbar: {
                show: true,
                message: ''
            },
            loadingProjects: true,
            loadingTopics: true
        }),
        computed: {
            ...mapGetters(['user', 'preferedLanguage'])
        },
        components: {
            Banner,
            ProjectCard
        },
        mounted() {
            this.fetchProjects()
            this.fetchTopics()
        },
        methods: {
            async fetchProjects() {
                await this.axios.get('/Project/GetAllProjects', {
                    params: {
                        languageId: this.preferedLanguage,
                        status: 'Open'
                    }
                })
                .then(response => {
                    this.bidingList = response.data.bidingList
                    this.votingList = response.data.votingList
                    this.reviewList = response.data.reviewList
                })
                .catch(error => {
                    this.snackbar.message = error.message
                    this.$EventBus.$emit('snackbar', this.snackbar)
                })
                this.loadingProjects = false
            },
            async fetchTopics() {
                await this.axios.get('/Topic/GetAllTopics', {
                    params: {
                        languageId: this.preferedLanguage
                    }
                })
                .then(response => {
                    this.topics = response.data
                })
                this.loadingTopics = false
            },
            topicById(id) {
                if(this.topics.length > 0) {
                    let index = this.topics.map(topic => {
                        return topic.id
                    }).indexOf(id)
                    return this.topics[index].name
                }
                return null
            }
        }
    }
</script>

<style lang="scss" scDped>

</style>